
import TermsOfUseModalComponent from "@/components/Modals/TermsOfUseModal/TermsOfUseModalComponent";
export default TermsOfUseModalComponent;
